import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Lobby from "@/pages/Lobby";
import Wallet from "@/pages/Wallet";
import Referrals from "@/pages/Referrals";
import Leaderboard from "@/pages/Leaderboard";
import DailyChallenge from "@/pages/DailyChallenge";
import MemoryGame from "@/pages/games/Memory";
import TwentyFortyEight from "@/pages/games/TwentyFortyEight";
import Minesweeper from "@/pages/games/Minesweeper";
import Chicken from "@/pages/games/Chicken";
import ChickenInfo from "@/pages/games/ChickenInfo";
import Realtor from "@/pages/games/Realtor";
import Jeff from "@/pages/games/Jeff";
import Frogger from "@/pages/games/Frogger";
import Unicorn from "@/pages/games/Unicorn";
import AdminWithdrawals from "@/pages/AdminWithdrawals";
import AdminRevenue from "@/pages/AdminRevenue";
import Shell from "@/components/Shell";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/auth" state={{ from: loc.pathname }} replace />;
  return <Shell>{children}</Shell>;
}

function App() {
  useEffect(() => { document.title = "VEXIS · Skill Casino"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/lobby" element={<Protected><Lobby /></Protected>} />
          <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
          <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
          <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
          <Route path="/daily" element={<Protected><DailyChallenge /></Protected>} />
          <Route path="/play/memory" element={<Protected><MemoryGame /></Protected>} />
          <Route path="/play/2048" element={<Protected><TwentyFortyEight /></Protected>} />
          <Route path="/play/minesweeper" element={<Protected><Minesweeper /></Protected>} />
          <Route path="/play/chicken" element={<Protected><Chicken /></Protected>} />
          <Route path="/play/chicken/info" element={<Protected><ChickenInfo /></Protected>} />
          <Route path="/play/realtor" element={<Protected><Realtor /></Protected>} />
          <Route path="/play/jeff" element={<Protected><Jeff /></Protected>} />
          <Route path="/play/frogger" element={<Protected><Frogger /></Protected>} />
          <Route path="/play/unicorn" element={<Protected><Unicorn /></Protected>} />
          <Route path="/admin/withdrawals" element={<Protected><AdminWithdrawals /></Protected>} />
          <Route path="/admin/revenue" element={<Protected><AdminRevenue /></Protected>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
